module.exports = __webpack_public_path__ + "img/outfield-picnic-pavilion-01.680000c6.jpeg";